import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { Trackable } from '../tracking/trackingData';

export const goToWorkspace = actionCreator<Trackable<{ workspaceId: ArdoqId }>>(
  '[WORKSPACE MANAGER] Go to workspace'
);

export const dragInitiated = actionCreator(
  '[WORKSPACE MANAGER] Drag initiated in workspace sidebar'
);

export const dragCompleted = actionCreator(
  '[WORKSPACE MANAGER] Drop completed in workspace sidebar'
);

export const dragEnteredDropZone = actionCreator<string>(
  '[WORKSPACE MANAGER] Drag entered drop zone in workspace sidebar'
);

export const dragExitedDropZone = actionCreator<string>(
  '[WORKSPACE MANAGER] Drag exited drop zone in workspace sidebar'
);
